import React from 'react';

import InvoiceLineItemEntryTableRow from './InvoiceLineItemEntryTableRow';
import LineItemEntry from '../../Entities/LineItemEntry';

import './InvoiceLineItemEntryTable.scss';
import featureFlags from '../../featureFlags';

class InvoiceLineItemEntryTable extends React.Component {
  _onLineItemEntryChange(ident) {
    return value => {
      this.props.onLineItemEntryChange(ident, value);
    };
  }

  addBlankEntryToTable() {
    const entry = new LineItemEntry();
    this._onLineItemEntryChange(null)(entry);
  }

  handleAddEntryClick = () => {
    this.addBlankEntryToTable();
  }

  render() {
    const {
      lineItemEntryRows = [],
      inputId,
      newMode,
      adjustmentMode,
      fieldConfiguration,
      taxExempt
    } = this.props;

    return (
      <div className="parkchirp--invoice-line-item-entry-table">
        <React.Fragment>
          <header className="parkchirp--invoice-line-item-entry-table--header">
            <div className="parkchirp--invoice-line-item-entry-table--row">
            <div className="parkchirp--invoice-line-item-entry-table--leading-spacer-column"></div>
              <div className="parkchirp--invoice-line-item-entry-table--date-column parkchirp--invoice-line-item-entry-table--cell">
                <span className="parkchirp--invoice-line-item-entry-table--column-heading">{ featureFlags.APPLICATION_DATE ? "Trans. Date" :  "Date"}</span>
              </div>
              {featureFlags.APPLICATION_DATE &&
                <div className="parkchirp--invoice-line-item-entry-table--date-column parkchirp--invoice-line-item-entry-table--cell">
                  <span className="parkchirp--invoice-line-item-entry-table--column-heading">App. Date</span>
                </div>
              }
              <div className="parkchirp--invoice-line-item-entry-table--type-column parkchirp--invoice-line-item-entry-table--cell">
                <span className="parkchirp--invoice-line-item-entry-table--column-heading">Type</span>
              </div>
              <div className="parkchirp--invoice-line-item-entry-table--net-amount-column parkchirp--invoice-line-item-entry-table--cell">
                <span className="parkchirp--invoice-line-item-entry-table--column-heading">Net Amount</span>
              </div>
              <div className="parkchirp--invoice-line-item-entry-table--amount-tax-1-column parkchirp--invoice-line-item-entry-table--cell">
                <span className="parkchirp--invoice-line-item-entry-table--column-heading">Tax 1</span>
              </div>
              <div className="parkchirp--invoice-line-item-entry-table--amount-tax-2-column parkchirp--invoice-line-item-entry-table--cell">
                <span className="parkchirp--invoice-line-item-entry-table--column-heading">Tax 2</span>
              </div>
              <div className="parkchirp--invoice-line-item-entry-table--amount-tax-3-column parkchirp--invoice-line-item-entry-table--cell">
                <span className="parkchirp--invoice-line-item-entry-table--column-heading">Tax 3</span>
              </div>
              <div className="parkchirp--invoice-line-item-entry-table--amount-tax-4-column parkchirp--invoice-line-item-entry-table--cell">
                <span className="parkchirp--invoice-line-item-entry-table--column-heading">Tax 4</span>
              </div>
              <div className="parkchirp--invoice-line-item-entry-table--gross-amount-column parkchirp--invoice-line-item-entry-table--cell">
                <span className="parkchirp--invoice-line-item-entry-table--column-heading">Gross Amount</span>
              </div>
              <div className="parkchirp--invoice-line-item-entry-table--actions-column parkchirp--invoice-line-item-entry-table--cell">
              </div>
            </div>
          </header>
          <div className="parkchirp--invoice-line-item-entry-table--body">
            {lineItemEntryRows.map(lineItemEntryRow =>
              <div className="parkchirp--invoice-line-item-entry-table--row"
                key={lineItemEntryRow.ident}>
                <InvoiceLineItemEntryTableRow inputId={`${inputId}--${lineItemEntryRow.ident}`}
                  lineItemEntry={lineItemEntryRow.data}
                  newMode={newMode}
                  onChange={this._onLineItemEntryChange(lineItemEntryRow.ident)}
                  fieldConfiguration={fieldConfiguration}
                  taxExempt={taxExempt}
                  adjustmentMode={adjustmentMode}
                />
              </div>
            )}
            {(adjustmentMode) &&
              <div className="parkchirp--invoice-line-item-entry-table--row parkchirp--invoice-line-item-entry-table--add-entry-row">
                <div className={!featureFlags.APPLICATION_DATE ? "parkchirp--invoice-line-item-entry-table--leading-spacer-column" : "app-date-column"}></div>
                <div className={`${!featureFlags.APPLICATION_DATE ? "parkchirp--invoice-line-item-entry-table--add-entry-column" : "app-date-cell"} parkchirp--invoice-line-item-entry-table--cell`}>
                  <button type="button"
                    className="parkchirp--button-as-link"
                    onClick={this.handleAddEntryClick}>
                    Add Adjustment Entry
                  </button>
                </div>
              </div>
            }
          </div>
        </React.Fragment>
      </div>
    );
  }
}

export default InvoiceLineItemEntryTable;
